import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer className="border-t border-[#243044] bg-[#0B1220] mt-24">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
                    <div>
                        <div className="flex items-center gap-3 mb-4">
                            <div className="h-9 px-2 flex items-center justify-center rounded-md bg-white">
                                <img
                                    src={require("../assets/logo-tcp-mark.png")}
                                    alt="The Context Project"
                                    className="h-6 w-auto select-none"
                                    draggable={false}
                                />
                            </div>
                            <div>
                                <div className="text-sm font-bold text-white">The Context Project</div>
                                <div className="text-[10px] uppercase tracking-[0.2em] text-[#64748B]">Research Library</div>
                            </div>
                        </div>
                        <p className="text-sm text-[#94A3B8] leading-relaxed max-w-xs">
                            Evidence-based breakdowns of complex, controversial, and misunderstood topics.
                        </p>
                    </div>

                    <div>
                        <div className="text-xs uppercase tracking-[0.18em] text-[#64748B] font-medium mb-4">Library</div>
                        <ul className="space-y-2">
                            <li><Link to="/" className="text-sm text-[#94A3B8] hover:text-white transition-colors">All Topics</Link></li>
                            <li><Link to="/timeline" className="text-sm text-[#94A3B8] hover:text-white transition-colors">Master Timeline</Link></li>
                            <li><Link to="/entities" className="text-sm text-[#94A3B8] hover:text-white transition-colors">Entity Index</Link></li>
                            <li><Link to="/sources" className="text-sm text-[#94A3B8] hover:text-white transition-colors">Source Vault</Link></li>
                            <li><Link to="/saved" className="text-sm text-[#94A3B8] hover:text-white transition-colors">Saved</Link></li>
                            <li><Link to="/methodology" className="text-sm text-[#94A3B8] hover:text-white transition-colors">Methodology</Link></li>
                            <li><Link to="/about" className="text-sm text-[#94A3B8] hover:text-white transition-colors">About</Link></li>
                            <li>
                                <a
                                    href="https://thecontextproject.com"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-sm text-[#56CCF2] hover:text-white transition-colors inline-flex items-center gap-1"
                                >
                                    Main site ↗
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://thecontextproject.com/pages/report-an-issue"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-sm text-[#94A3B8] hover:text-white transition-colors"
                                >
                                    Report an issue
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <div className="text-xs uppercase tracking-[0.18em] text-[#64748B] font-medium mb-4">Compiled by</div>
                        <p className="text-sm text-white font-medium">
                            <a
                                href="https://www.facebook.com/people/Bill-Mathers/61578352413913/"
                                target="_blank"
                                rel="noreferrer"
                                data-testid="footer-bill-mathers-fb"
                                className="hover:text-[#56CCF2] transition-colors"
                            >
                                Bill Mathers
                            </a>
                        </p>
                        <p className="text-xs text-[#64748B] mt-1">The Context Project</p>
                        <div className="mt-4 flex flex-col gap-1.5">
                            <a
                                href="https://www.facebook.com/TheContextProject/"
                                target="_blank"
                                rel="noreferrer"
                                data-testid="footer-tcp-fb"
                                className="text-xs text-[#94A3B8] hover:text-[#56CCF2] transition-colors inline-flex items-center gap-1"
                            >
                                The Context Project on Facebook ↗
                            </a>
                        </div>
                    </div>
                </div>

                <div className="mt-10 pt-6 border-t border-[#243044] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                    <p className="text-xs text-[#64748B]">
                        &copy; {new Date().getFullYear()} The Context Project. All sources cited; interpretation is yours.
                    </p>
                    <p className="text-xs text-[#64748B]">
                        Calm. Structured. Evidence-based.
                    </p>
                </div>
            </div>
        </footer>
    );
}
